export default __webpack_public_path__ + "static/media/logo_visit.558254c0.png";